export class UpdateUserInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "givenName",
            "baseName": "givenName",
            "type": "string",
            "format": ""
        },
        {
            "name": "roleToProjectsMappings",
            "baseName": "roleToProjectsMappings",
            "type": "{ [key: string]: IDs; }",
            "format": ""
        },
        {
            "name": "expiresAt",
            "baseName": "expiresAt",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateUserInput.attributeTypeMap;
    }
    constructor() {
    }
}
